<template>
  <v-dialog
    v-model="value"
    :persistent="true"
    width="500"
    lazy
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-form ref="form">
      <v-card class="pa-4">
        <v-layout justify-center class="title green--text my-2">
          <span>Utilizador</span>
        </v-layout>
        <v-layout wrap justify-space-between>
          <v-flex class="ma-2" xs12>
            <v-text-field label="Email" type="email" v-model="email" />
            <v-text-field label="Username" v-model="username" />
            <v-text-field label="First Name" v-model="firstName" />
            <v-text-field label="Last Name" v-model="lastName" />
            <v-text-field label="License" type="number" v-model="license" />
            <v-autocomplete
              label="Hospital"
              :items="institutionSelections"
              :loading="loading"
              v-model="hospital"
            />
            <v-select
              label="Specialty"
              :items="specialtySelections"
              v-model="specialty"
            />
            <v-select
              label="Roles"
              :items="roleSelections"
              :loading="loading"
              v-model="roles"
              multiple
            />
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-btn color="success" :loading="inviting" @click="invite">
            Atualizar
          </v-btn>
          <v-btn color="error" depressed @click="show = false" class="mx-2">
            Rejeitar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import cms from '@/content'
import { Hospital, HealthCenterGroup } from '../../models/Content'
export default {
  name: 'AddUserDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      email: '',
      firstName: '',
      lastName: '',
      username: '',
      hospital: '',
      license: '',
      specialty: '',
      roles: [],
      loading: false,
      inviting: false
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        if (!value) {
          this.clear()
        }
        this.$emit('input', value)
      }
    },
    roleSelections() {
      return cms.getRoles(this.$i18n.locale)
    },
    institutionSelections() {
      return this.specialty === 'family-medicine'
        ? HealthCenterGroup.query().get()
        : Hospital.query().get()
    },
    specialtySelections() {
      return cms.getSpecialties(this.$i18n.locale)
    }
  },
  methods: {
    async invite() {
      const url = `${process.env.VUE_APP_API_URL}/auth0/users`
      const body = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        name: `${this.firstName} ${this.lastName}`,
        username: this.username,
        hospital: this.hospital,
        specialty: this.specialty,
        license: Number(this.license),
        roles: this.roles
      }

      this.inviting = true
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.$store.getters['accessToken']}`
          },
          body: JSON.stringify(body)
        })

        const { statusCode, ...responseBody } = await res.json()

        this.inviting = false

        if (statusCode < 200 || statusCode >= 300) {
          this.$store.dispatch(
            'showErrorSnackbar',
            responseBody.message || 'Erro no servidor'
          )
        } else {
          this.$store.dispatch('showSuccessSnackbar', 'Utilizador Registado')
          this.clear()
          this.show = false
        }
      } catch (error) {
        this.$store.dispatch('showErrorSnackbar', 'Erro no servidor')
        console.log(error)
      }
    },

    clear() {
      this.email = ''
      this.firstName = ''
      this.lastName = ''
      this.username = ''
      this.hospital = ''
      this.license = ''
      this.specialty = ''
      this.roles = []
    }
  },
  async created() {
    if (!HealthCenterGroup.query().first() || !Hospital.query().first()) {
      this.loading = true
      try {
        await Hospital.fetch()
        await HealthCenterGroup.fetch()
      } catch (error) {
        this.$store.dispatch(
          'showErrorSnackbar',
          'Could not fetch hospital data'
        )
        console.log(error)
      }
      this.loading = false
    }
  }
}
</script>
